import { SourceNode } from "../source-node";

export type GroupedNodeList = {[nodeType: string]: SourceNode[]}
export class ASTNodeDescriptor {
    constructor(
        readonly name:string,
        classList: string[],
        readonly sourceNodes: GroupedNodeList
    ) {
        this._classList = new Set(classList);
    }

    private _classList: Set<string>;
    get classList() { return new Set(this._classList); }

    private _descendantCount = 0;
    /**
     * The number of descendants this node has.
     * We need to keep track of this in order to traverse the
     * tree of nodes as we are using an array-based tree structure.
     */
    get descendantCount() { return this._descendantCount }

    /**
     * Increases the descendant count.
     * @param descendants The list of descendants which are being added to this node.
     */
    public increaseDecendantCount(descendants: ASTNodeDescriptor[]) {
        this._descendantCount += descendants.length;
    }
}